import React from 'react'
import { useTranslation } from 'i18n'

import PlaceholderImage from 'components/PlaceholderImage'
import { DropdownButton } from '../parts/DropdownButton2'
import { legacyImageURL } from 'components/LegacyImage'

/*
This is used for 1,2,3 column layouts.
1 column is a very different ui. 
may want to pull that into separate component to make things more maintainable.
*/
const ReferralCard = ({link, i, layout, dropdownOpenHandler, handleLinkClick, linkClickHandler}) => {

  const { t } = useTranslation('referral')

  const imageUrl = link.headerImage
        ? `${process.env.SITE_ASSET_URL}/${link.headerImage.id}`
        : ''

  if (link.buttonType === 'MENU') {

    return (

      <div
        className={`referral-card dropdown-card bottom-${i} ${link.puckCardClass ?? ''}`}
        style={link.puckCardStyle}
        key={i}
      >
          {/* legacy scss paints dropdown-inside, not the card root — puck
              card styles (background/border/shadow) apply here */}
          <div className={`dropdown-inside`} style={link.puckCardStyle}>
            {link.puckCardBorderOverlayStyle && (
              <div aria-hidden style={link.puckCardBorderOverlayStyle} />
            )}
            {link.puckMedia ? (
              <div className="referral-image-dropdown">
                {link.puckMedia}
                {link.puckMediaHover && (
                  <div className="puck-media-hover">{link.puckMediaHover}</div>
                )}
              </div>
            ) : (
              link.headerImage && (
                <div className="referral-image-dropdown">
                  <PlaceholderImage
                    src={legacyImageURL(link.headerImage)}
                    height={400}
                    width={600}
                    alt={link.headerImage?.altAttribute || ''}
                  />
                </div>
              )
            )}
            {(link.topText || link.bottomText) && (
              <div className="description">
                {link.topText && (
                  <span
                    dangerouslySetInnerHTML={{ __html: link.topText }}
                  ></span>
                )}
                {link.bottomText && (
                  <span
                    dangerouslySetInnerHTML={{ __html: link.bottomText }}
                  ></span>
                )}
              </div>
            )}
            {link.puckExtraContent}
            <DropdownButton
              text={link.menu.text || t('pickProductCta')}
              onDropdownOpen={dropdownOpenHandler}
              items={link.menu.items}
              onClick={linkClickHandler}
              color={link.buttonColor}
              textColor={link.menuTextColor}
              hoverColor={link.menuHoverColor}
              extraButtonStyle={link.extraButtonStyle}
              groupStyle={link.groupStyle}
              order={i}
              menuID={link.id}
            />
          </div>
      </div>
    )
  } else if (link.buttonType === 'BUTTON') {
    return (
      <div
        key={i}
        className={`referral-card button-card card-${layout !== 'ONE_COLUMN' || false} ${link.puckCardClass ?? ''}`}
        style={link.puckCardStyle}
      >
          {link.puckCardBorderOverlayStyle && (
            <div aria-hidden style={link.puckCardBorderOverlayStyle} />
          )}
          {link.puckMedia && (
            // puck media slot content; only wrapped in the tracking link when
            // the card has a target url (legacy image-click behavior)
            link.url ? (
              <a
                href={link.url}
                key={i + '-a'}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => {
                  handleLinkClick(link)
                }}
              >
                <div className="referral-image">
                  {link.puckMedia}
                  {link.puckMediaHover && (
                    <div className="puck-media-hover">{link.puckMediaHover}</div>
                  )}
                </div>
              </a>
            ) : (
              <div className="referral-image">
                {link.puckMedia}
                {link.puckMediaHover && (
                  <div className="puck-media-hover">{link.puckMediaHover}</div>
                )}
              </div>
            )
          )}
          {layout !== 'ONE_COLUMN' && !link.puckMedia && link.headerImage && (
            <a
              href={link.url}
              key={i + '-a'}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => {
                handleLinkClick(link)
              }}
            >
              <div
                className="referral-image"
              >
                <PlaceholderImage
                  src={legacyImageURL(link.headerImage)}
                  height={400}
                  width={600}
                  alt={link.headerImage?.altAttribute || ''}
                />
              </div>
            </a>
          )}
          <div className="referral-bottom">
            {(link.topText || link.bottomText) && (
              <div className="description">
                {link.topText && (
                  <span
                    dangerouslySetInnerHTML={{ __html: link.topText }}
                  ></span>
                )}
                {link.bottomText && (
                  <span
                    dangerouslySetInnerHTML={{ __html: link.bottomText }}
                  ></span>
                )}
              </div>
            )}
            {link.puckExtraContent}
            {link.showButton === true && (
              <a
                href={link.url}
                key={i + '-b'}
                target="_blank"
                rel="noopener noreferrer"
                className={`shop-btn ${link.puckButtonVars ? 'puck-shop-btn' : ''}`}
                style={{
                  color: '#fff',
                  // puck buttons style via CSS vars so :hover can override
                  // (inline background would always win over the hover rule);
                  // puckButtonStyle may carry its own text color
                  ...(link.puckButtonVars ?? { background: link.buttonColor }),
                  ...(link.puckButtonStyle ?? {}),
                }}
                onClick={() => {
                  handleLinkClick(link)
                }}
              >
                {link.puckButtonOverlayStyle && (
                  <span aria-hidden style={link.puckButtonOverlayStyle} />
                )}
                {link.buttonText}
              </a>
            )}
          </div>
        
      </div>
    )
  } else {
    console.warn(`unhandled link type '${ link.buttonType }'`)
  }


}

export default ReferralCard